(() => {
  if (typeof window.CustomEvent === 'function') return false; // If not IE

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;

  return true;
})();

export const REFRESH_NUDGE_ARROWS = new CustomEvent('refreshNudgeArrows');
export const COMPONENT_DELETED = new CustomEvent('componentDeleted');
export const RESET_SLIDER = new CustomEvent('onsliderreset', { detail: {} });
export const UPLOAD_COMPLETED = new CustomEvent('ondownloaduploaded');



// WEBPACK FOOTER //
// ./resources/assets/js/core6/Core6Events.js